import { useSelector } from 'react-redux';
import { IApplicationState } from '../../store';

export const useSurveyDefaultCultureCode = () => {
	const { defaultCultureCode } = useSelector((state: IApplicationState) => state.survey.surveyEditModel);

	return defaultCultureCode;
};
